/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { B2BUnitNode } from './B2BUnitNode';
import {
    B2BUnitNodeFromJSON,
    B2BUnitNodeFromJSONTyped,
    B2BUnitNodeToJSON,
} from './B2BUnitNode';

/**
 * Representation of an organizational unit node list
 * @export
 * @interface B2BUnitNodeList
 */
export interface B2BUnitNodeList {
    /**
     * List of Unit Nodes
     * @type {Array<B2BUnitNode>}
     * @memberof B2BUnitNodeList
     */
    unitNodes: Array<B2BUnitNode>;
}

/**
 * Check if a given object implements the B2BUnitNodeList interface.
 */
export function instanceOfB2BUnitNodeList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "unitNodes" in value;

    return isInstance;
}

export function B2BUnitNodeListFromJSON(json: any): B2BUnitNodeList {
    return B2BUnitNodeListFromJSONTyped(json, false);
}

export function B2BUnitNodeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BUnitNodeList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unitNodes': ((json['unitNodes'] as Array<any>).map(B2BUnitNodeFromJSON)),
    };
}

export function B2BUnitNodeListToJSON(value?: B2BUnitNodeList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unitNodes': ((value.unitNodes as Array<any>).map(B2BUnitNodeToJSON)),
    };
}

